import React, { useState, useEffect, useCallback, useRef } from 'react';
import MuxPlayer from '@mux/mux-player-react';
import './Gallery.css';

const Gallery = () => {
    // TODO: Replace placeholder Mux Playback IDs with your actual IDs after uploading to Mux
    const mediaItems = [
        { type: 'video', playbackId: 'xl500lGWbV1vQfdjbywClr302Bx2A2rK01DkQZXYWODxsk' }, // GALLERY KOTTO 1.mp4
        { type: 'video', playbackId: 'VJ277W72BVkXNIBXM9VqxEI5ZNK5GJ7iqyHHgDyIC6M' }, // GALLERY KOTTO 2.mp4
        { type: 'video', playbackId: 'k8kX6lLTR1lPedNXIMdbu676pAY5qYV3ycpukuAw3Po' }, // GALLERY KOTTO 3.mp4
        { type: 'image', src: '/GALLERY KOTTO 5.JPEG' },
        { type: 'video', playbackId: 'xCG8xxJ1DTYzFe2dAEJkCGqcP02OZSUJXZEdLqs7j2RE' }, // GALLERY KOTTO 6.mp4
        { type: 'video', playbackId: 'EKF6jfmP328GsHK4HfPe02NiPosiTvNAxrhidKIz2es8' }, // GALLERY KOTTO 9.mp4
        { type: 'image', src: '/GALLERY KOTTO 11.JPG' },
        { type: 'image', src: '/GALLERY KOTTO 12.jpg' },
        { type: 'image', src: '/Photo 23-03-2024, 13 28 58.jpg' }
    ];

    const [lightboxIndex, setLightboxIndex] = useState(null);
    const galleryRef = useRef(null);

    const isVideo = (item) => {
        return item.type === 'video';
    };

    const openLightbox = (index) => {
        setLightboxIndex(index);
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
        setLightboxIndex(null);
        document.body.style.overflow = 'unset';
    };

    const nextImage = useCallback(() => {
        setLightboxIndex((prevIndex) =>
            prevIndex === mediaItems.length - 1 ? 0 : prevIndex + 1
        );
    }, [mediaItems.length]);

    const prevImage = useCallback(() => {
        setLightboxIndex((prevIndex) =>
            prevIndex === 0 ? mediaItems.length - 1 : prevIndex - 1
        );
    }, [mediaItems.length]);

    // Scroll gallery left/right
    const scrollGallery = (direction) => {
        if (galleryRef.current) {
            const scrollAmount = 320; // width of item + gap
            galleryRef.current.scrollBy({
                left: direction === 'right' ? scrollAmount : -scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    // Keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (lightboxIndex === null) return;

            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowRight') nextImage();
            if (e.key === 'ArrowLeft') prevImage();
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [lightboxIndex, nextImage, prevImage]);

    return (
        <section className="gallery-section">
            <h2>GALLERY</h2>
            <div className="gallery-wrapper">
                <button className="gallery-scroll-btn gallery-scroll-left" onClick={() => scrollGallery('left')}>
                    &#10094;
                </button>
                <div className="gallery-grid" ref={galleryRef}>
                    {mediaItems.map((item, index) => (
                        <div
                            key={index}
                            className="gallery-item"
                            onClick={(e) => {
                                const isMobile = window.innerWidth <= 768;

                                if (isVideo(item) && isMobile) {
                                    // Handle video click on mobile: native fullscreen
                                    const videoElement = e.currentTarget.querySelector('video');
                                    if (videoElement) {
                                        if (videoElement.requestFullscreen) {
                                            videoElement.requestFullscreen();
                                        } else if (videoElement.webkitRequestFullscreen) { /* Safari */
                                            videoElement.webkitRequestFullscreen();
                                        } else if (videoElement.msRequestFullscreen) { /* IE11 */
                                            videoElement.msRequestFullscreen();
                                        }
                                        videoElement.play();
                                        videoElement.muted = false; // Unmute on fullscreen
                                        videoElement.controls = true; // Show controls on fullscreen
                                    }
                                } else {
                                    // Handle image click (or video on desktop): lightbox
                                    openLightbox(index);
                                }
                            }}
                            onMouseEnter={() => {
                                if (isVideo(item)) {
                                    // Optional: play preview on hover (if desired, currently default behavior is fine)
                                    // const video = document.querySelectorAll('.gallery-item video')[index];
                                    // if(video) video.play();
                                }
                            }}
                            onMouseLeave={() => {
                                if (isVideo(item)) {
                                    // Optional: pause preview on hover leave
                                    // const video = document.querySelectorAll('.gallery-item video')[index];
                                    // if(video) { video.pause(); video.currentTime = 0; }
                                }
                            }}
                        >
                            {isVideo(item) ? (
                                <MuxPlayer
                                    playbackId={item.playbackId}
                                    streamType="on-demand"
                                    muted
                                    playsInline
                                    className="gallery-thumbnail"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            ) : (
                                <img src={item.src} alt={`KOTTO Gallery ${index + 1}`} loading="lazy" className="gallery-thumbnail" />
                            )}
                        </div>
                    ))}
                </div>
                <button className="gallery-scroll-btn gallery-scroll-right" onClick={() => scrollGallery('right')}>
                    &#10095;
                </button>
            </div>

            {lightboxIndex !== null && (
                <div className="lightbox-overlay">
                    <button className="lightbox-close" onClick={closeLightbox}>&times;</button>
                    <button className="lightbox-prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>&#10094;</button>

                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        {isVideo(mediaItems[lightboxIndex]) ? (
                            <MuxPlayer
                                playbackId={mediaItems[lightboxIndex].playbackId}
                                streamType="on-demand"
                                controls
                                autoPlay
                                playsInline
                                className="lightbox-media"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '90vh',
                                    objectFit: 'contain'
                                }}
                            />
                        ) : (
                            <img
                                src={mediaItems[lightboxIndex].src}
                                alt={`KOTTO Fullscreen ${lightboxIndex + 1}`}
                                className="lightbox-media"
                            />
                        )}
                    </div>

                    <button className="lightbox-next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>&#10095;</button>
                </div>
            )}
        </section>
    );
};

export default Gallery;
